import React, { useState } from 'react';
import { Typography, Card, CardContent, Grid, TextField, InputAdornment, Tabs, Tab, Box, Button, Chip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useNavigate } from 'react-router-dom';
import { marketplaceItems } from '../helpers/MockData';

export default function AppHub() {
  const [tabValue, setTabValue] = useState(0);
  const [filteredItems, setFilteredItems] = useState(marketplaceItems);
  const navigate = useNavigate();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    filterItems(newValue);
  };

  const filterItems = (tabIndex) => {
    const categories = ["All", "Productivity", "Analysis", "Integration"];
    const selectedCategory = categories[tabIndex];
    setFilteredItems(
      selectedCategory === "All"
        ? marketplaceItems
        : marketplaceItems.filter(item => item.category === selectedCategory)
    );
  };

  const handleLaunch = (e, item) => {
    e.stopPropagation();
    if (item.name === "Meeting Summarizer") {
      navigate('/meeting-summarizer');
    } else if (item.name === "PioChat") {
      navigate('/piochat');
    } else if (item.name === "PaaS") {
      navigate('/paas');
    } else if (item.name === "No-Code AI") {
      navigate('/no-code-ai');
    } else if (item.name === "HashCat") {
      navigate('/hashcat');
    } else if (item.name === "PioAgent") {
      window.open('https://pioagent.piosphere.ai', '_blank');
    } else if (item.name === "Callbot") {
      navigate('/callbot');
    } else if (item.name === "PioWidget") {
      navigate('/piowidget');
    }
  };

  return (
    <Box sx={{ 
      px: { xs: 2, sm: 2, md: 3 },
      pt: 2,
      pb: { xs: 2, sm: 2, md: 3 },
      width: '100%',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search apps"
        size={window.innerWidth < 600 ? "small" : "medium"}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        sx={{ 
          mb: { xs: 2, sm: 3 },
          '& .MuiOutlinedInput-root': {
            fontSize: { xs: '0.875rem', sm: '1rem' }
          }
        }}
      />
      
      <Box sx={{ 
        borderBottom: 1, 
        borderColor: 'divider',
        width: '100%',
        mb: { xs: 2, sm: 3 }
      }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            maxWidth: '100%',
            minHeight: 'unset',
            '& .MuiTab-root': {
              minHeight: 'unset',
              padding: { xs: '8px 12px', sm: '12px 16px' },
              fontSize: { xs: '0.8rem', sm: '0.875rem', md: '1rem' },
              minWidth: { xs: 'auto', sm: 90 },
              textTransform: 'none',
              fontWeight: 500
            }
          }}
        >
          <Tab label="All" />
          <Tab label="Productivity" />
          <Tab label="Analysis" />
          <Tab label="Integration" />
        </Tabs>
      </Box>

      <Grid 
        container 
        spacing={{ xs: 2, sm: 2, md: 3 }}
        sx={{ 
          width: '100%',
          margin: 0
        }}
      >
        {filteredItems.map((item) => (
          <Grid 
            item 
            xs={12} 
            sm={6} 
            md={4} 
            lg={3} 
            key={item.id}
            sx={{
              display: 'flex'
            }}
          >
            <Card 
              sx={{ 
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4
                },
                '& .MuiCardContent-root': {
                  p: { xs: 2, sm: 2 }
                },
                '& .MuiCardContent-root:last-child': {
                  paddingBottom: { xs: 2, sm: 2 }
                }
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Typography variant="h6" sx={{
                    fontSize: { xs: '1rem', sm: '1.25rem' },
                    fontWeight: 600,
                    lineHeight: 1.3
                  }}>
                    {item.name}
                  </Typography>
                  {item.name !== 'PioAgent' && item.name !== 'PioWidget' && (
                    <Chip 
                      label="Coming Soon" 
                      size="small" 
                      color="warning"
                      sx={{ 
                        fontSize: { xs: '0.6rem', sm: '0.65rem' },
                        height: { xs: '16px', sm: '18px' },
                        '& .MuiChip-label': {
                          px: { xs: 0.75, sm: 1 },
                          py: 0
                        }
                      }}
                    />
                  )}
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ 
                  mb: 2,
                  fontSize: { xs: '0.8rem', sm: '0.875rem' },
                  lineHeight: 1.4
                }}>
                  {item.description}
                </Typography>
              </CardContent>
              <CardContent sx={{ pt: 0 }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  size={window.innerWidth < 600 ? "small" : "medium"}
                  startIcon={<PlayArrowIcon />}
                  onClick={(e) => handleLaunch(e, item)}
                  sx={{
                    fontSize: { xs: '0.8rem', sm: '0.875rem' },
                    py: { xs: 1, sm: 1.25 },
                    fontWeight: 600
                  }}
                >
                  Launch
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

